import React from 'react'
import Constructor from '../components/constructor/Constructor'

const ConstructorPage = () => {
  return (
    <div><Constructor /></div>
  )
}

export default ConstructorPage